/*!
 * Local Project Js File
 *
 */

window.requestAnimFrame = (function(){
  return  window.requestAnimationFrame       ||
          window.webkitRequestAnimationFrame ||
          window.mozRequestAnimationFrame    ||
          window.oRequestAnimationFrame      ||
          window.msRequestAnimationFrame     ||
          function( callback ){
            window.setTimeout(callback, 1000 / 60);
          };
})();

(function () {

  "use strict";

  var myApp = {
  }

  myApp.init = function() {

    var smoothItem = $('.smooth-scroll-link');
    var sideNav = $('.side-nav-slide');
    var ticking = false;
    var last_known_scroll_position;

    ruralApp.Flexslider.initFlex('.flexslider',{animation: 'fade', controlNav: false});
    ruralApp.MagnificPopup.initMagnific('.gallery', {delegate: 'a', type: 'image', gallery: { enabled:true }});


    //smooth scroll navigation
    for (var i = 0, length = smoothItem.length; i < length; i++) {
      smoothItem[i].addEventListener('click', function(ev) {
        console.log('click smooth');
        ev.preventDefault();
        if (location.pathname.replace(/^\//,'') == this.pathname.replace(/^\//,'') && location.hostname == this.hostname) {
          var target = $(this.hash);
          target = target.length ? target : $('[name=' + this.hash.slice(1) +']');
          if (target.length) {
            $('html, body').animate({
              scrollTop: target.offset().top
            }, 1000);
            return false;
          }
        }
      });
    }

    if (sideNav.length) {
      // var headerTop = this.$header.outerHeight(true),
      var sideNavW = sideNav.outerWidth(),
          sideNavT = sideNav.offset().top,
          navbarT = $('#header').outerHeight(true),
          topHeaderT = $('#top-header').outerHeight(true),
          sideNavH = sideNav.outerHeight(true),
          // mainContainerH = $('.main-container-content').outerHeight(true),
          footerTop = $('#footer').outerHeight(true),
          footerBottom = $('#footer-bottom').outerHeight(true);

      if (window.innerWidth > 991) {
        sideNav.affix({
          offset: {
            top: function(){return sideNavT - navbarT - topHeaderT - 40},
            bottom: footerTop + footerBottom + 30
          }
        });
      }
    }

    window.addEventListener('scroll', function(e) {
      last_known_scroll_position = window.scrollY;
      if (!ticking) {
        window.requestAnimationFrame(function() {
          checkScrollPos(last_known_scroll_position);
          ticking = false;
        });
      }
      ticking = true;

      $(".animateItem").each(function(i, el) {
        var el = $(el);
        if (el.visible(true)) {
          el.addClass("animated");
        }
      });
    });

    function checkScrollPos(scroll_pos) {
      if (scroll_pos > 43) {
        $('#header').removeClass('navbar-static-top');
        $('#header').addClass('navbar-fixed-top');
      } else {
        $('#header').removeClass('navbar-fixed-top');
        $('#header').addClass('navbar-static-top');
      }
    }


  }




  document.addEventListener('DOMContentLoaded', function() {
    myApp.init();
  }, false);


})();
